import { useEffect, useRef, useState } from "react";

/* Verbatim copy of the private hook in InsightsLineChart.jsx (EP blueprint
   §2.4): the rendered width of an element, with a fallback before layout.
   Used by PerformanceStepChart only; InsightsLineChart.jsx is not modified. */
export default function useElementWidth(fallback = 320) {
  const ref = useRef(null);
  const [width, setWidth] = useState(fallback);
  useEffect(() => {
    const element = ref.current;
    if (!element) return undefined;
    const measure = () => {
      const next = Math.round(element.getBoundingClientRect().width);
      if (next > 0) setWidth(next);
    };
    measure();
    if (typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  return [ref, width];
}
